import { ITextProps, Text } from '@fluentui/react'
import * as React from 'react'
import { ReactElement } from 'react'
import { formatDistance } from '../../../helpers/numberHelper'

type Props = {
    /** The distance in American notation (12.50); it is formatted for display here. */
    value?: string | number
    unit?: string
    textProps?: ITextProps
}

export default function DistanceText({ value, unit, textProps }: Props): ReactElement {
    if (value === undefined || value === null || value === '') {
        return <></>
    }

    const text = (
        <>
            {formatDistance(value)}
            <small> {unit || 'km'}</small>
        </>
    )

    return textProps ? <Text {...textProps}>{text}</Text> : text
}
